module.exports = __webpack_public_path__ + "static/media/20.6028957b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/20.jpg
// module id = 195
// module chunks = 0